import React from 'react';
import { formatCurrencyAmount } from '../../utils/profitability';
import './ProfitabilityMonthsTable.css';

const ProfitabilityMonthsTable = ({ months, currencies, data }) => (
  <div className="months-table">
    <div className="months-table-header">
      <span>Mes</span>
      {currencies.map((currency) => (
        <span key={currency}>{currency}</span>
      ))}
    </div>
    <div className="months-table-body">
      {months.map((m, index) => {
        const row = data[index];
        const isZero = currencies.every((c) => !(row?.values[c]));
        return (
          <div key={m.value} className={`months-table-row${isZero ? ' months-table-row--muted' : ''}`}>
            <span>{m.short}</span>
            {currencies.map((currency) => {
              const value = row?.values[currency] ?? 0;
              return (
                <span
                  key={currency}
                  className={value > 0 ? 'positive' : value < 0 ? 'negative' : ''}
                >
                  {formatCurrencyAmount(value, currency)}
                </span>
              );
            })}
          </div>
        );
      })}
    </div>
  </div>
);

export default ProfitabilityMonthsTable;
